import React from "react";
import tw, { styled } from "twin.macro";
import FooterSection from "./FooterSection";
import SocialMedia from "./SocialMedia";
import _ from "lodash";

const ContainerWrapper = styled.footer`
  ${tw`min-h-[300px] bg-[#EC1F27]`}
  background-color: ${(props) => props.color}
`;
const Container = styled.div`
  ${tw`
    mx-auto p-4
    md:max-w-3xl lg:max-w-5xl xl:max-w-7xl 2xl:max-w-[90em]
  `}
`;
const Grid = styled.div`
  ${tw`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 pt-2`}
`;

const Title = styled.div`
  ${tw`text-white text-lg uppercase pt-4 sm:py-4`}
`;

const Footer = ({
  data,
  color,
  ticketLinks,
  getTeamLinks,
  rosterLinks,
  facilityLinks,
  fanExperienceLinks,
  aboutLinks,
  baseballLinks,
  socialMediaData,
}) => {
  const rosterPagePath = _.get(data, "latestRosterPage.nodes.0.path", "/");

  return (
    <ContainerWrapper color={color}>
      <Container>
        <Grid>
          <div>
            <Title>Social Media</Title>
            <SocialMedia
              iconWidth="30px"
              iconHeight="30px"
              iconColor="white"
              backgroundColor="#212121"
              bgWidth="50px"
              gridDisplay={true}
              socialMediaData={socialMediaData}
            />
          </div>
          {rosterLinks && <FooterSection title="Teams" links={rosterLinks} />}
          {ticketLinks && <FooterSection title="Tickets" links={ticketLinks} />}
          {getTeamLinks && (
            <FooterSection
              title="Team Info"
              links={getTeamLinks(rosterPagePath)}
            />
          )}
          {facilityLinks && (
            <FooterSection title="Facilities" links={facilityLinks} />
          )}
          {fanExperienceLinks && (
            <FooterSection title="Fan Experience" links={fanExperienceLinks} />
          )}
          {aboutLinks && <FooterSection title="About" links={aboutLinks} />}
          {baseballLinks && (
            <FooterSection title="Baseball Links" links={baseballLinks} />
          )}
        </Grid>
      </Container>
    </ContainerWrapper>
  );
};

export default Footer;
